export default __webpack_public_path__ + "static/media/avatar-bg.07ea7637.png";